export default "__VITE_ASSET__WBofyQhB__"